import marked from 'marked';
const defaultRenderer = new marked.Renderer();

export default function useMarkedImgRenderer() {
    defaultRenderer.image = function(href, title, text) {
        return `
            <div>
                <img src="${href}" class="img-fluid w-100" alt="${title}"></img>
                <figcaption class="text-right">${text}</figcaption>
            </div>
        `
    }

    marked.setOptions({renderer: defaultRenderer});
}